import { dbFS } from '@/services/firebaseInit';
import httpClient from '@/modules/httpModule';
import { cloudFunctionsPost } from '../../modules/cloud-function-wrapper.js';
import moment from 'moment';
import mapsService from '../../services/mapsService.js';

const state = {
  ldpOrderProcess: [],
  ldpMapData: null
};

const getters = {
  getLdpOrderProcess(state) {
    return state.ldpOrderProcess;
  },
  getLdpMapData(state) {
    return state.ldpMapData;
  }
};

const mutations = {
  setLdpOrderProcess(state, payload) {
    const verifySteps = state.ldpOrderProcess.filter(process => process.step === payload.step);
    if (verifySteps.length > 0) {
      Object.assign(state.ldpOrderProcess[state.ldpOrderProcess.map(process => process.step)?.indexOf(payload.step)], payload);
    } else {
      state.ldpOrderProcess.push(payload);
    }
  },
  clearLdpOrderProcess(state) {
    state.ldpOrderProcess = [];
  },
  setLdpMapData(state, payload) {
    state.ldpMapData = payload;
  }
};

const actions = {
  addLdpOrderLog({ dispatch }, { firebase_order_id, action, data }) {
    return dispatch('logs/addOrderLog', { firebase_order_id, action, data }, { root: true });
  },
  sendRequest({ commit }, payload) {
    return cloudFunctionsPost(`/${payload.endpoint}`, payload.body);
  },
  getOrderRefById({ commit }, orderID) {
    return dbFS.collection('orders').doc(orderID);
  },
  setOrderAttribute({ commit }, payload) {
    return payload.orderRef.set(payload.changedAttr, { merge: true });
  },
  async updateLdpOrderInDatabase({ dispatch }, payload) {
    console.log('..... updateLdpOrderInDatabase ..... ', payload);
    const orderRef = await dispatch('getOrderRefById', payload.orderID);

    return orderRef
      .get()
      .then(querySnapshot => {
        const data = querySnapshot.data();

        payload.preparedObject.forEach(mediaPlanResult => {
          mediaPlanResult.is_map_express = mediaPlanResult.isExpress || false;
          delete mediaPlanResult.isExpress;
        });

        const savedLdpData =
          payload.propertyName === 'media_plans'
            ? data.ldp_order?.[payload.propertyName]?.filter(mediaPlan => mediaPlan.status !== 'error') || null
            : data.ldp_order?.[payload.propertyName]?.filter(ldpBooking => !ldpBooking.message) || null;

        if (savedLdpData) savedLdpData.push(...payload.preparedObject);

        const ldpOrder = {
          [payload.propertyName]: savedLdpData || payload.preparedObject
        };
        console.log('[ LDP ORDER TO UPDATE ]:', ldpOrder);

        return dispatch('setOrderAttribute', { orderRef, changedAttr: { ldp_order: ldpOrder } })
          .then(() => ({ status: 'success' }))
          .catch(error => Promise.reject(`Updating order with LDP data failed! ${error}`));
      })
      .catch(error => Promise.reject(`Getting Order data from database failed: ${error}`));
  },
  checkGeoCodes({ commit }, payload) {
    console.log('[checkGeoCodes payload]: ', payload);

    const startDateYMD = moment(payload.startDate).format('YYYY-MM-DD');
    console.log('Start Date:', startDateYMD);
    const endDateYMD = moment(payload.endDate).format('YYYY-MM-DD');
    console.log('End Date:', endDateYMD);
    const geoCodesString = payload.geoCodes.toString();

    return httpClient.get({
      baseUrl: ``,
      // baseUrl: `https://${payload.envType ? 'emapdatadev' : 'emapdata'}.adc4gis.com`,
      endpoint: 'availability',
      params: {
        ids: geoCodesString,
        startDate: startDateYMD,
        endDate: endDateYMD
      }
    });
  },
  async getMapData({ commit }, payload) {
    try {
      const mapData = await mapsService.getMapData(payload.mapId);
      console.log('[ MapData ]: ', mapData);
      commit('setLdpMapData', mapData);
      commit('setLdpOrderProcess', { step: 1, status: 'success', data: mapData });
      return mapData;
    } catch (error) {
      commit('setLdpOrderProcess', { step: 1, status: 'error', data: error });
      throw error;
    }
  },

  async submitLdpOrder({ commit, dispatch }, payload) {
    const specialCharacters = /[`'"!@#$%^&*()_+{}[\]:;<>,.?~\\/-]/g;
    console.log('[ Submit LDP Order payload:', payload);
    const dateFormats = ['YYYY-MM-DD', 'DD-MMM-YYYY', 'MMMM, DD YYYY HH:mm:ss'];

    commit('clearLdpOrderProcess');
    commit('setLdpOrderProcess', { step: `1-${payload.week}`, message: `Getting advertisement date from map` });

    const ldpMapData =  await mapsService.getMapData(payload.mapId);
    const geoCodes = ldpMapData?.atz_geocodes || [];
    console.log('[ GeoCodes ]:', geoCodes);

    if (!geoCodes.length) return Promise.reject({ message: `Map with ID ${payload.mapId} does not have geocodes saved! Submitting order request is cancelled!` });

    let week = payload.week || ldpMapData?.week || '';

    const convertedDate = moment(week, dateFormats);
    const advertisementDate = convertedDate.isValid() ? convertedDate.format('DD-MMM-YYYY') : moment(advertisementDate.toDate()).format('DD-MMM-YYYY');

    commit('setLdpOrderProcess', { step: `1-${payload.week}`, status: 'success', data: { week, advertisementDate, mapId: payload.mapId } });
    await dispatch('addLdpOrderLog', {
      firebase_order_id: payload.orderData.firebase_order_id,
      action: `Advertisement week and date from map: [ week: ${week}, advertisementDate: ${advertisementDate}]`
    });

    commit('setLdpOrderProcess', { step: `2-${advertisementDate}`, message: `Preparing data for sending the request for week ${advertisementDate}` });

    const clientInvoicePromotion = `${payload.orderData.crm_order_id.toString()} ${moment().format('DD-MM-YYYY')}`;
    const uniqueAdVersionCode = `OBM${payload.orderData.crm_order_id.toString()}`;
    const clientPO = payload.orderData.crm_customer_id.toString();
    const isExpress = payload.switchExpress ? 1 : null;

    const body = {
      order_type: payload.orderData.order_type,
      firebase_site_id: payload.orderData.site_db_id,
      isExpress: isExpress,
      advertisementDate: advertisementDate,
      crm: {
        orderId: payload.orderData.firebase_order_id
      },
      client: {
        clientName: payload.client.clientName.toUpperCase().replace(specialCharacters, ''),
        clientNameAppearingOnAd: payload.client.clientNameAppearingOnAd.toUpperCase().substring(0, 15).replace(specialCharacters, ''),
        clientPromotion: payload.client.clientPromotion.toUpperCase().substring(0, 30).replace(specialCharacters, ''),
        clientInvoicePromotion,
        clientPO
      },
      zipAtz: geoCodes,
      uniqueAdVersionCode,
      mapId: payload.mapId,
    };

    console.log('ldpSubmitOrder body:', body);
    commit('setLdpOrderProcess', { step: `2-${advertisementDate}`, status: 'success', data: body });
    dispatch('addLdpOrderLog', {
      firebase_order_id: payload.orderData.firebase_order_id,
      action: `Submit LDP order for week ${advertisementDate} request:`,
      data: body
    });
    commit('setLdpOrderProcess', { step: `3-${advertisementDate}`, message: `Submitting LDP order for week ${advertisementDate}` });

    return dispatch('sendRequest', { endpoint: 'ldp/submit-order', body })
      .then(response => {
        console.log('ldpSubmitOrder response:', response.data);
        commit('setLdpOrderProcess', { step: `3-${advertisementDate}`, status: 'success', data: response.data });

        const ldbObject = {
          isExpress: isExpress,
          ldpBookingOrderID: response?.data?.ldpBookingOrderID || null,
          ldp_booking_data: response?.data || null
        };
        if (!payload.isSubmitAllSelected && ldbObject.ldpBookingOrderID) {
          commit('setLdpOrderProcess', { step: 4, message: `Updating order data with LDP result` });
          dispatch('addLdpOrderLog', {
            firebase_order_id: payload.orderData.firebase_order_id,
            action: `Submit LDP order for week ${advertisementDate} result:`,
            data: ldbObject
          });

          return dispatch('updateLdpOrderInDatabase', {
            orderID: payload.orderData.firebase_order_id,
            propertyName: 'ldp_bookings',
            preparedObject: [ldbObject]
          })
            .then(() => {
              commit('setLdpOrderProcess', { step: 4, status: 'success', data: ldbObject });
              commit('setLdpOrderProcess', { step: 5, message: 'LDP order has been successfully sent for processing', status: 'success' });
              return Promise.resolve(ldbObject);
            })
            .catch(error => {
              commit('setLdpOrderProcess', { step: 4, status: 'error', data: { message: `Updating LDP order data in database failed: ${error}` } });
              return Promise.reject({ message: `Updating LDP order data in database failed: ${error}` });
            });
        }
        return Promise.resolve([ldbObject]);
      })
      .catch(error => {
        console.log('[ submitLdpOrder ] ERROR:', error);
        commit('setLdpOrderProcess', {
          step: `3-${advertisementDate}`,
          status: 'error',
          data: { message: `Sending request failed: ${JSON.stringify(error?.response?.data || error)}` }
        });
        dispatch('addLdpOrderLog', {
          firebase_order_id: payload.orderData.firebase_order_id,
          action: `Submit LDP order failed: ${JSON.stringify(error?.response?.data || error?.message || error)}`,
          data: error?.response?.data || error
        });
        return Promise.reject({ message: `Sending request failed: ${JSON.stringify(error?.response?.data)}` });
      });
  },
  async deleteLdpDataFromOrder({ dispatch }, payload) {
    console.log('[ Delete LDP data payload ]:', payload);
    const orderRef = await dispatch('getOrderRefById', payload.firebase_order_id);
    return orderRef.get().then(snapshot => {
      const orderData = snapshot.data();
      const ldpResults = {
        media_plans: orderData.ldp_order.media_plans,
        ldp_bookings: orderData.ldp_order.ldp_bookings
      };
      const mediaPlansToUpdate = ldpResults.media_plans.filter(mediaPlan => parseInt(mediaPlan.mailDropId) !== parseInt(payload.data.mailDropId));
      const ldpBookingsToUpdate = ldpResults.ldp_bookings.filter(ldpBooking => parseInt(ldpBooking.ldpBookingOrderID) !== parseInt(payload.data.ldpBookingOrderID));

      return dispatch('setOrderAttribute', {
        orderRef,
        changedAttr: {
          ldp_order: {
            ['media_plans']: mediaPlansToUpdate,
            ['ldp_bookings']: ldpBookingsToUpdate
          }
        }
      })
        .then(() => ({ status: 'success' }))
        .catch(error => Promise.reject(`Updating order with LDP data failed! ${error}`));
    });
  },
  submitAllLdpOrders({ commit, dispatch }, payload) {
    console.log('[ Submit all LDPs payload ]:', payload);
    const ldpResultPromises = [];
    if (payload.weeks) {
      commit('clearLdpOrderProcess');
      payload.weeks.forEach((week, index) => {
        ldpResultPromises.push(
          dispatch('submitLdpOrder', {
            envType: payload.envType,
            mapId: payload.mapId,
            orderData: payload.orderData,
            ospreyOrderId: payload.orderData.crm_order_id,
            firebaseOrderId: payload.firebaseOrderId,
            switchExpress: week.isExpress || false,
            week: week.date,
            client: payload.client,
            isSubmitAllSelected: true
          })
        );
      });
      return Promise.allSettled(ldpResultPromises).then(results => {
        commit('setLdpOrderProcess', { step: 4, message: `Updating order data with LDP result` });
        console.log('[ Submit all LDP Orders promises results ]:', results);

        const ldpResultsToUpdateInOrder = [];
        results.forEach(result => {
          if (result.value) {
            ldpResultsToUpdateInOrder.push(...result.value);
          } else if (result.reason) {
            ldpResultsToUpdateInOrder.push(result.reason);
          }
        });

        return dispatch('updateLdpOrderInDatabase', {
          orderID: payload.firebaseOrderId,
          propertyName: 'ldp_bookings',
          preparedObject: ldpResultsToUpdateInOrder
        })
          .then(() => {
            commit('setLdpOrderProcess', { step: 4, status: 'success', data: ldpResultsToUpdateInOrder });
            commit('setLdpOrderProcess', { step: 5, message: 'Order submitted successfully', status: 'success' });
            return Promise.resolve(ldpResultsToUpdateInOrder);
          })
          .catch(error => {
            commit('setLdpOrderProcess', { step: 4, status: 'error', data: { message: `Updating LDP order data in database failed: ${error}` } });
            return Promise.reject({ message: `Updating LDP order data in database failed: ${error}` });
          });
      });
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
